// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2B7A1","title":"FrontImage_title__31CWW"};